// theme
import palette from '../theme/palette';

// ----------------------------------------------------------------------

export const colorPresets = [
  // DEFAULT
  {
    name: 'default',
    ...palette.light.primary,
  },
  // PURPLE
  {
    name: 'purple',
    lighter: '#EBD6FD',
    light: '#B985F4',
    main: '#7635dc',
    dark: '#431A9E',
    darker: '#200A69',
    contrastText: '#fff',
  },
  // CYAN
  {
    name: 'cyan',
    lighter: '#D1FFFC',
    light: '#76F2FF',
    main: '#1CCAFF',
    dark: '#0E77B7',
    darker: '#053D7A',
    contrastText: palette.light.grey[800],
  },
  // BLUE
  {
    name: 'blue',
    lighter: '#E0E0FF',
    light: '#3131FF',
    main: '#0202E9',
    dark: '#0000A7',
    darker: '#00007C',
    contrastText: '#fff',
    palette: {
      50: '#FAFAFF',
      100: '#E0E0FF',
      200: '#8282FF',
      300: '#6666FF',
      400: '#3131FF',
      500: '#0000FF',
      600: '#0202E9',
      700: '#0202CA',
      800: '#0000A7',
      900: '#00007C',
    },
  },
  // ORANGE
  {
    name: 'orange',
    lighter: '#FFEFEB',
    light: '#FF6F4D',
    main: '#FF4D23',
    dark: '#CF3C18',
    darker: '#B13213',
    contrastText: '#fff',
    palette: {
      50: '#FFF8F6',
      100: '#FFEFEB',
      200: '#FFA793',
      300: '#FF8D72',
      400: '#FF6F4D',
      500: '#FF4D23',
      600: '#E8441D',
      700: '#CF3C18',
      800: '#BF3818',
      900: '#B13213',
    },
  },
  // RED
  {
    name: 'red',
    lighter: '#FFE3D5',
    light: '#FFC1AC',
    main: '#FF3030',
    dark: '#B71833',
    darker: '#7A0930',
    contrastText: '#fff',
  },
  // PINK
  {
    name: 'pink',
    lighter: '#fce4ec',
    light: '#ff94c2',
    main: '#f06292',
    dark: '#ba2d65',
    darker: '#78002e',
    contrastText: '#fff',
  },
  // LILA
  {
    name: 'lila',
    lighter: '#fff1ff',
    light: '#ffc4ff',
    main: '#ce93d8',
    dark: '#9c64a6',
    darker: '#af8eb5',
    contrastText: '#fff',
  },
];

export const defaultPreset = colorPresets[0];
export const purplePreset = colorPresets[1];
export const cyanPreset = colorPresets[2];
export const bluePreset = colorPresets[3];
export const orangePreset = colorPresets[4];
export const redPreset = colorPresets[5];
export const pinkPreset = colorPresets[6];
export const lilaPreset = colorPresets[7];

export default function getColorPresets(presetsKey) {
  return {
    purple: purplePreset,
    cyan: cyanPreset,
    blue: bluePreset,
    orange: orangePreset,
    red: redPreset,
    default: defaultPreset,
    pink: pinkPreset,
    lila: lilaPreset,
  }[presetsKey];
}
